<!--top header start-->
<header>
    <div class="container-fluid">
        <div class="row">
            <div class="col">
                <div class="top-header">
                    <div class="logo">
                        <a class="navbar-brand" href="#"><img src="assets/images/landing/logo.png" alt="logo"></a>
                    </div>
                    <div class="main-menu m-x-auto" id="nav">
                        <nav id="navbar-example2" class="navbar navbar-expand-lg navbar-light">
                            <button class="navbar-toggler" type="button" data-toggle="collapse"
                                data-target="#scroll-spy" aria-controls="scroll-spy" aria-expanded="false"
                                aria-label="Toggle navigation">
                                <span class="navbar-toggler-icon"></span>
                            </button>
                            <div class="collapse navbar-collapse" id="scroll-spy">
                                <ul class="navbar-nav mx-auto nav">
                                    <li class="nav-item">
                                        <a class="nav-link active" #home (click)="active('home')" [ngClass]="{'active show': activeClass == 'home' }">Home</a>
                                    </li>
                                    <li class="nav-item">
                                        <a class="nav-link" (click)="active('pages')" [ngClass]="{'active show': activeClass == 'pages' }" >pages</a>
                                    </li>
                                    <li class="nav-item">
                                        <a class="nav-link" (click)="active('portfolio')" [ngClass]="{'active show': activeClass == 'portfolio' }">portfolio</a>
                                    </li>
                                    <li class="nav-item">
                                        <a class="nav-link" (click)="active('feature')" [ngClass]="{'active show': activeClass == 'feature' }">features</a>
                                    </li>
                                    <li class="nav-item">
                                        <a class="nav-link" href="https://pixelstrap.freshdesk.com">support</a>
                                    </li>
                                </ul>
                            </div>
                        </nav>
                    </div>
                    <div class="purchase-block">
                        <span class="cartpurchase"><i class="fa fa-cart-arrow-down"></i></span>
                        <a class="purchase-btn" href="https://themeforest.net/user/pixelstrap/portfolio">purchase</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</header>
<!--top header end-->

<!--gif section start-->
<section class="home-section pb-0" id="home">
    <div class="container">
        <div class="row">
            <div class="col-8 offset-2">
                <div>
                    <div class="home-container">
                        <div class="home-logo-container">
                            <img src="assets/images/landing/home/main-icon.png" alt="" class="img-fluid logo">
                        </div>
                        <h1>One stop for all one page landings...</h1>
                        <p>
                            Unice is Perfect landing HTML template for any business. it has all
                            features and modules to create your amazing landing page. you can use
                            this template for selling Agency, app landding, coffee, event, gym, music, digital, pizza,
                            resume, sass, wedding, yoga etc.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="home-contain">
        <ul>
            <li class="inner-slide1"><img src="assets/images/landing/home/2.png" class="img-fluid"></li>
            <li class="inner-slide2"><img src="assets/images/landing/home/3.png" class="img-fluid"></li>

            <li class="inner-slide4"><img src="assets/images/landing/home/4.png" class="img-fluid"></li>
            <li class="inner-slide5"><img src="assets/images/landing/home/5.png" class="img-fluid"></li>
        </ul>
    </div>
    <div class="animate-gif">
        <img src="assets/images/landing/animate-icon/squar.png" class="img-fluid hom-suar1">
        <img src="assets/images/landing/animate-icon/squar.png" class="img-fluid hom-suar2">
        <img src="assets/images/landing/animate-icon/ract.png" class="img-fluid hom-ract1">
        <img src="assets/images/landing/animate-icon/ract.png" class="img-fluid hom-ract2">
        <img src="assets/images/landing/animate-icon/round-3.png" class="img-fluid hom-round1">
        <img src="assets/images/landing/animate-icon/round-4.png" class="img-fluid hom-round2">
        <img src="assets/images/landing/animate-icon/sib-2.png" class="img-fluid hom-sib2">
        <img src="assets/images/landing/animate-icon/cloud1.png" class="img-fluid hom-cloud1">
        <img src="assets/images/landing/animate-icon/cloud2.png" class="img-fluid hom-cloud2">
        <img src="assets/images/landing/animate-icon/cloud3.png" class="img-fluid hom-cloud3">
        <img src="assets/images/landing/animate-icon/cloud4.png" class="img-fluid hom-cloud4">
    </div>
    <div class="inner-slide3"><img src="assets/images/landing/home/12.png" class="main-gif img-fluid"></div>
</section>

<!--gif section end-->

<!--What's inside Unice start-->
<section class="whatinside" id="main-feature">
    <div class="container">
        <div class="position-relative o-hidden">
            <div class="text-as-bg">
                <h1>Features</h1>
            </div>
            <div class="title">
                <h2>Reasones To Buy Unice </h2>
                <hr class="bottom-border">
            </div>
        </div>
        <div class="row top_feature">
            <div class="col-md-4">
                <div class="inside_box">
                    <svg viewBox="0 0 496 496" xmlns="http://www.w3.org/2000/svg"><path d="m120 208h256v16h-256zm0 0"/><path d="m272 240h104v16h-104zm0 0"/><path d="m120 240h104v16h-104zm0 0"/><path d="m272 176h104v16h-104zm0 0"/><path d="m120 176h104v16h-104zm0 0"/><path d="m120 144h256v16h-256zm0 0"/><path d="m424 185.367188v-41.367188c0-26.472656-21.527344-48-48-48v16c17.648438 0 32 14.351562 32 32v41.367188c0 14.183593 4.679688 27.65625 13.320312 38.632812-8.640624 10.976562-13.320312 24.449219-13.320312 38.632812v41.367188c0 17.648438-14.351562 32-32 32v16c26.472656 0 48-21.527344 48-48v-41.367188c0-12.457031 4.847656-24.167968 13.65625-32.976562l5.65625-5.65625-5.65625-5.65625c-8.808594-8.808594-13.65625-20.511719-13.65625-32.976562zm0 0"/><path d="m88 304v-41.367188c0-14.183593-4.679688-27.65625-13.320312-38.632812 8.640624-10.976562 13.320312-24.449219 13.320312-38.632812v-41.367188c0-17.648438 14.351562-32 32-32v-16c-26.472656 0-48 21.527344-48 48v41.367188c0 12.457031-4.847656 24.167968-13.65625 32.976562l-5.65625 5.65625 5.65625 5.65625c8.808594 8.808594 13.65625 20.511719 13.65625 32.976562v41.367188c0 26.472656 21.527344 48 48 48v-16c-17.648438 0-32-14.351562-32-32zm0 0"/><path d="m248 352c-17.648438 0-32 14.351562-32 32s14.351562 32 32 32 32-14.351562 32-32-14.351562-32-32-32zm0 48c-8.824219 0-16-7.175781-16-16s7.175781-16 16-16 16 7.175781 16 16-7.175781 16-16 16zm0 0"/><path d="m248 320c-10.625 0-21.160156 2.664062-30.457031 7.695312l7.625 14.074219c6.96875-3.769531 14.855469-5.769531 22.832031-5.769531 26.472656 0 48 21.527344 48 48 0 7.976562-2 15.863281-5.769531 22.832031l14.074219 7.625c5.03125-9.296875 7.695312-19.832031 7.695312-30.457031 0-35.289062-28.710938-64-64-64zm0 0"/><path d="m248 432c-26.472656 0-48-21.527344-48-48 0-7.976562 2-15.863281 5.769531-22.832031l-14.074219-7.625c-5.03125 9.296875-7.695312 19.832031-7.695312 30.457031 0 35.289062 28.710938 64 64 64 10.625 0 21.160156-2.664062 30.457031-7.695312l-7.625-14.074219c-6.96875 3.769531-14.855469 5.769531-22.832031 5.769531zm0 0"/><path d="m496 24c0-13.230469-10.769531-24-24-24h-448c-13.230469 0-24 10.769531-24 24v368h136v14.246094l20.023438 5.011718c1.90625 6.414063 4.472656 12.605469 7.671874 18.496094l-10.632812 17.710938 31.457031 31.457031 17.710938-10.632813c5.890625 3.207032 12.082031 5.773438 18.496093 7.671876l5.027344 20.039062h44.492188l5.011718-20.023438c6.414063-1.90625 12.605469-4.472656 18.496094-7.671874l17.710938 10.632812 31.457031-31.457031-10.632813-17.710938c3.207032-5.890625 5.773438-12.082031 7.671876-18.496093l20.039062-5.027344v-14.246094h136zm-472-8h448c4.40625 0 8 3.59375 8 8v40h-464v-40c0-4.40625 3.59375-8 8-8zm320 377.753906-17.167969 4.292969-1.136719 4.714844c-1.941406 8.078125-5.144531 15.78125-9.496093 22.894531l-2.535157 4.136719 9.121094 15.191406-13.792968 13.792969-15.191407-9.121094-4.136719 2.535156c-7.113281 4.351563-14.816406 7.550782-22.894531 9.496094l-4.714843 1.136719-4.300782 17.175781h-19.507812l-4.292969-17.167969-4.714844-1.136719c-8.078125-1.941406-15.78125-5.144531-22.894531-9.496093l-4.136719-2.535157-15.191406 9.121094-13.792969-13.792968 9.121094-15.191407-2.535156-4.136719c-4.351563-7.113281-7.550782-14.816406-9.496094-22.894531l-1.136719-4.714843-17.175781-4.300782v-19.507812l17.167969-4.292969 1.136719-4.714844c1.941406-8.078125 5.144531-15.78125 9.496093-22.894531l2.535157-4.136719-9.121094-15.191406 13.792968-13.792969 15.191407 9.121094 4.136719-2.535156c7.113281-4.351563 14.816406-7.550782 22.894531-9.496094l4.714843-1.136719 4.300782-17.175781h19.507812l4.292969 17.167969 4.714844 1.136719c8.078125 1.941406 15.78125 5.144531 22.894531 9.496093l4.136719 2.535157 15.191406-9.121094 13.792969 13.792968-9.121094 15.191407 2.535156 4.136719c4.351563 7.113281 7.550782 14.816406 9.496094 22.894531l1.136719 4.714843 17.175781 4.300782zm16-17.753906v-14.246094l-20.023438-5.011718c-1.90625-6.414063-4.472656-12.605469-7.671874-18.496094l10.632812-17.710938-31.457031-31.457031-17.710938 10.632813c-5.890625-3.207032-12.082031-5.773438-18.496093-7.671876l-5.027344-20.039062h-44.492188l-5.011718 20.023438c-6.414063 1.90625-12.605469 4.472656-18.496094 7.671874l-17.710938-10.632812-31.457031 31.457031 10.632813 17.710938c-3.207032 5.890625-5.773438 12.082031-7.671876 18.496093l-20.039062 5.027344v14.246094h-120v-296h464v296zm0 0"/><path d="m32 32h16v16h-16zm0 0"/><path d="m64 32h16v16h-16zm0 0"/><path d="m96 32h16v16h-16zm0 0"/></svg>
                    <h3>No jQuery Dependency</h3>
                    <p>JQuery is great library but as angular comes with declarative style and high performance it's not
                        a greate idea to use</p>
                </div>
            </div>
            <div class="col-md-4">
                <div class="inside_box">
                        <svg xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 512 512">
                            <g id="surface1">
                            <path d="M 488.90625 84 L 384 84 C 379.855469 84 376.5 87.355469 376.5 91.5 C 376.5 95.644531 379.855469 99 384 99 L 488.90625 99 C 493.371094 99 497 102.628906 497 107.09375 L 497 395.90625 C 497 400.371094 493.371094 404 488.90625 404 L 23.09375 404 C 18.628906 404 15 400.371094 15 395.90625 L 15 107.09375 C 15 102.628906 18.628906 99 23.09375 99 L 187.875 99 L 187.875 114 L 37.5 114 C 33.355469 114 30 117.355469 30 121.5 L 30 319.667969 C 30 323.808594 33.355469 327.167969 37.5 327.167969 C 41.644531 327.167969 45 323.808594 45 319.667969 L 45 129 L 187.875 129 L 187.875 169.234375 L 155.765625 184.574219 C 153.203125 185.800781 151.5 188.449219 151.5 191.34375 L 151.5 313.65625 C 151.5 316.546875 153.160156 319.179688 155.765625 320.425781 L 252.765625 366.769531 C 254.867188 367.757812 257.238281 367.707031 259.234375 366.769531 L 313.765625 340.714844 C 317.503906 338.929688 319.085938 334.449219 317.300781 330.714844 C 315.515625 326.976562 311.03125 325.394531 307.296875 327.179688 L 263.5 348.105469 L 263.5 242.414062 L 345.5 203.238281 L 345.5 308.929688 L 334.359375 314.25 C 330.621094 316.035156 329.039062 320.515625 330.824219 324.25 C 332.609375 327.988281 337.089844 329.570312 340.824219 327.785156 L 356.234375 320.425781 C 358.839844 319.179688 360.5 316.546875 360.5 313.65625 L 360.5 191.34375 C 360.5 188.484375 358.835938 185.820312 356.234375 184.574219 L 324.125 169.234375 L 324.125 129 L 467 129 L 467 374 L 45 374 L 45 351.667969 C 45 347.523438 41.644531 344.167969 37.5 344.167969 C 33.355469 344.167969 30 347.523438 30 351.667969 L 30 381.5 C 30 385.644531 33.355469 389 37.5 389 L 474.5 389 C 478.644531 389 482 385.644531 482 381.5 L 482 121.5 C 482 117.355469 478.644531 114 474.5 114 L 324.125 114 L 324.125 99 L 352 99 C 356.144531 99 359.5 95.644531 359.5 91.5 C 359.5 87.355469 356.144531 84 352 84 L 324.125 84 L 324.125 69 L 391.375 69 C 395.519531 69 398.875 65.644531 398.875 61.5 L 398.875 43.710938 C 407.605469 40.613281 413.875 32.277344 413.875 22.5 C 413.875 10.09375 403.78125 0 391.375 0 C 378.96875 0 368.875 10.09375 368.875 22.5 C 368.875 32.277344 375.144531 40.613281 383.875 43.710938 L 383.875 54 L 316.625 54 C 312.480469 54 309.125 57.355469 309.125 61.5 L 309.125 84 L 263.5 84 L 263.5 43.710938 C 272.230469 40.613281 278.5 32.277344 278.5 22.5 C 278.5 10.09375 268.40625 0 256 0 C 243.59375 0 233.5 10.09375 233.5 22.5 C 233.5 32.277344 239.769531 40.613281 248.5 43.710938 L 248.5 84 L 202.875 84 L 202.875 61.5 C 202.875 57.355469 199.519531 54 195.375 54 L 128.125 54 L 128.125 43.710938 C 136.855469 40.613281 143.125 32.277344 143.125 22.5 C 143.125 10.09375 133.03125 0 120.625 0 C 108.21875 0 98.125 10.09375 98.125 22.5 C 98.125 32.277344 104.394531 40.613281 113.125 43.710938 L 113.125 61.5 C 113.125 65.644531 116.480469 69 120.625 69 L 187.875 69 L 187.875 84 L 23.09375 84 C 10.359375 84 0 94.359375 0 107.09375 L 0 395.90625 C 0 408.640625 10.359375 419 23.09375 419 L 185.695312 419 C 182.792969 446.511719 164.601562 462.578125 158.867188 467 L 127 467 C 114.59375 467 104.5 477.09375 104.5 489.5 C 104.5 501.90625 114.59375 512 127 512 L 385 512 C 397.40625 512 407.5 501.90625 407.5 489.5 C 407.5 477.09375 397.40625 467 385 467 L 353.152344 467 C 347.492188 462.59375 329.238281 446.382812 326.3125 419 L 488.90625 419 C 501.640625 419 512 408.640625 512 395.90625 L 512 107.09375 C 512 94.359375 501.640625 84 488.90625 84 Z M 391.375 15 C 395.511719 15 398.875 18.363281 398.875 22.5 C 398.875 26.636719 395.511719 30 391.375 30 C 387.238281 30 383.875 26.636719 383.875 22.5 C 383.875 18.363281 387.238281 15 391.375 15 Z M 256 15 C 260.136719 15 263.5 18.363281 263.5 22.5 C 263.5 26.636719 260.136719 30 256 30 C 251.863281 30 248.5 26.636719 248.5 22.5 C 248.5 18.363281 251.863281 15 256 15 Z M 120.625 15 C 124.761719 15 128.125 18.363281 128.125 22.5 C 128.125 26.636719 124.761719 30 120.625 30 C 116.488281 30 113.125 26.636719 113.125 22.5 C 113.125 18.363281 116.488281 15 120.625 15 Z M 202.875 129 L 248.5 129 L 248.5 140.269531 L 202.875 162.070312 Z M 335.601562 191.34375 L 256 229.371094 L 176.398438 191.34375 L 256 153.3125 Z M 166.5 203.238281 L 248.5 242.414062 L 248.5 348.105469 L 166.5 308.929688 Z M 309.125 162.070312 L 263.5 140.269531 L 263.5 129 L 309.125 129 Z M 309.125 99 L 309.125 114 L 263.5 114 L 263.5 99 Z M 248.5 99 L 248.5 114 L 202.875 114 L 202.875 99 Z M 392.5 489.5 C 392.5 493.636719 389.136719 497 385 497 L 127 497 C 122.863281 497 119.5 493.636719 119.5 489.5 C 119.5 485.363281 122.863281 482 127 482 L 385 482 C 389.136719 482 392.5 485.363281 392.5 489.5 Z M 331.640625 467 L 180.359375 467 C 189.152344 456.730469 198.90625 440.726562 200.777344 419 L 311.222656 419 C 313.09375 440.726562 322.847656 456.730469 331.640625 467 Z M 331.640625 467 " style=" stroke:none;fill-rule:nonzero;fill:rgb(0%,0%,0%);fill-opacity:1;" />
                            </g>
                            </svg>
                    <h3>SSR (Server Side Rendering)</h3>
                    <p>With SSR you can rich a page 20X faster with SEO friendly</p>
                </div>
            </div>
            <div class="col-md-4">
                <div class="inside_box">
                        <svg id="Layer_5" enable-background="new 0 0 64 64" viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg"><path d="m55 33v-8h-8v-8h-8.261c-1.445-9.053-9.286-16-18.739-16-10.477 0-19 8.523-19 19 0 8.003 4.981 14.852 12 17.647v9.353h8v8h8v8h34v-30zm-51.949-12h7.993c.127 2.996.789 5.682 1.708 8h-7.148c-1.472-2.347-2.382-5.073-2.553-8zm16.949-17.599c.902.935 2.579 2.868 4.073 5.599h-8.146c1.494-2.731 3.171-4.664 4.073-5.599zm5.054 7.599c1.002 2.283 1.758 4.977 1.901 8h-13.91c.143-3.023.9-5.717 1.901-8zm11.895 8h-7.993c-.127-2.996-.789-5.682-1.708-8h7.148c1.472 2.347 2.382 5.073 2.553 8zm-25.906 0h-7.992c.172-2.927 1.081-5.653 2.554-8h7.148c-.92 2.318-1.583 5.004-1.71 8zm2.002 2h13.911c-.143 3.023-.9 5.717-1.901 8h-10.109c-1.001-2.283-1.758-4.977-1.901-8zm11.028 10c-1.494 2.731-3.171 4.664-4.073 5.599-.902-.935-2.579-2.869-4.073-5.599zm2.289 0h6.576c-2.6 3.053-6.256 5.164-10.4 5.789 1.132-1.322 2.579-3.276 3.824-5.789zm8.034-2h-7.148c.919-2.318 1.582-5.004 1.708-8h7.993c-.171 2.927-1.081 5.653-2.553 8zm-1.458-20h-6.576c-1.245-2.513-2.692-4.467-3.824-5.789 4.144.624 7.801 2.736 10.4 5.789zm-15.477-5.789c-1.131 1.322-2.578 3.276-3.823 5.789h-6.576c2.599-3.053 6.256-5.165 10.399-5.789zm-10.399 27.789h6.576c1.245 2.513 2.692 4.467 3.823 5.789-4.143-.625-7.8-2.736-10.399-5.789zm7.938 7.31c1.596.437 3.267.69 5 .69 10.477 0 19-8.523 19-19 0-.338-.033-.667-.051-1h6.051v26h-30zm8 8.69h24v-20h6v26h-30zm38 14h-30v-6h24v-20h6z"/><path d="m15 15h2v2h-2z"/><path d="m19 15h2v2h-2z"/><path d="m23 15h2v2h-2z"/><path d="m15 23h2v2h-2z"/><path d="m19 23h2v2h-2z"/><path d="m23 23h2v2h-2z"/><path d="m17 41h2v2h-2z"/><path d="m21 41h2v2h-2z"/><path d="m25 41h2v2h-2z"/><path d="m49 29h2v2h-2z"/><path d="m49 33h2v2h-2z"/><path d="m49 37h2v2h-2z"/><path d="m33 57h2v2h-2z"/><path d="m37 57h2v2h-2z"/><path d="m41 57h2v2h-2z"/></svg>
                    <h3>All in one (Multipurpose)</h3>
                    <p>JQuery is great library but as angular comes with declarative style and high performance it's not
                        a greate idea to use</p>
                </div>
            </div>
        </div>
    </div>
</section>
<!--What's inside Unice ends-->


<!--demo section start-->
<section class="app-preview-section pt-0" id="pages"> 
    <div class="container-fluid">
        <div class="position-relative o-hidden">
            <div class="text-as-bg">
                <h1>home<span>page</span></h1>
            </div>
            <div class="title">
                <h2>+13 Pre Define </h2>
                <h6>demolayouts</h6>
                <hr class="bottom-border">
            </div>
        </div>
        <div class="container">
            <div class="row">
                <div class="col-xl-4 col-sm-6 text-center demo-effects">
                    <a [routerLink]="['/agency']" class="app-preview demo-layouts">
                        <div class="trans-section">
                            <h4 class="preview-header">Agency Layout </h4>
                        </div>
                        <div class="layout-images">
                            <div class="layout-container image-1"></div>
                        </div>
                    </a>
                </div>
                <div class="col-xl-4 col-sm-6 text-center demo-effects">
                    <a [routerLink]="['/enterprice']" class="app-preview demo-layouts">
                        <div class="trans-section">
                            <h4 class="preview-header">Enterprise App Layout </h4>
                        </div>
                        <div class="layout-images">
                            <div class="layout-container image-2"></div>
                        </div>
                    </a>
                </div>
                <div class="col-xl-4 col-sm-6 text-center demo-effects">
                    <a [routerLink]="['/modern']" class="app-preview demo-layouts">
                        <div class="trans-section">
                            <h4 class="preview-header">Morden App Layout</h4>
                        </div>
                        <div class="layout-images">
                            <div class="layout-container image-3"></div>
                        </div>
                    </a>
                </div>
                <div class="col-xl-4 col-sm-6 text-center demo-effects">
                    <a [routerLink]="['/event']" class="app-preview demo-layouts">
                        <div class="trans-section">
                            <h4 class="preview-header">Event Layout</h4>
                        </div>
                        <div class="layout-images">
                            <div class="layout-container image-4"></div>
                        </div>
                    </a>
                </div>
                <div class="col-xl-4 col-sm-6 text-center demo-effects">
                    <a [routerLink]="['/gym']" class="app-preview demo-layouts">
                        <div class="trans-section">
                            <h4 class="preview-header">Gym Layout</h4>
                        </div>
                        <div class="layout-images">
                            <div class="layout-container image-5"></div>
                        </div>
                    </a>
                </div>
                <div class="col-xl-4 col-sm-6 text-center demo-effects">
                    <a [routerLink]="['/music']" class="app-preview demo-layouts">
                        <div class="trans-section">
                            <h4 class="preview-header">music Layout</h4>
                        </div>
                        <div class="layout-images">
                            <div class="layout-container image-6"></div>
                        </div>
                    </a>
                </div>
                <div class="col-xl-4 col-sm-6 text-center demo-effects">
                    <a [routerLink]="['/resume']" class="app-preview demo-layouts">
                        <div class="trans-section">
                            <h4 class="preview-header">Resume Layout</h4>
                        </div>
                        <div class="layout-images">
                            <div class="layout-container image-7"></div>
                        </div>
                    </a>
                </div>
                <div class="col-xl-4 col-sm-6 text-center demo-effects">
                    <a [routerLink]="['/enterprice-sass']" class="app-preview demo-layouts">
                        <div class="trans-section">
                            <h4 class="preview-header">Enterprise sass Layout</h4>
                        </div>
                        <div class="layout-images">
                            <div class="layout-container image-8"></div>
                        </div>
                    </a>
                </div>
                <div class="col-xl-4 col-sm-6 text-center demo-effects">
                    <a [routerLink]="['/modern-sass']" href="" class="app-preview demo-layouts">
                        <div class="trans-section">
                            <h4 class="preview-header">Modern Sass Layout </h4>
                        </div>
                        <div class="layout-images">
                            <div class="layout-container image-9"></div>
                        </div>
                    </a>
                </div>
                <div class="col-xl-4 col-sm-6 text-center demo-effects">
                    <a [routerLink]="['/wedding']" class="app-preview demo-layouts">
                        <div class="trans-section">
                            <h4 class="preview-header">Wedding Layout </h4>
                        </div>
                        <div class="layout-images">
                            <div class="layout-container image-10"></div>
                        </div>
                    </a>
                </div>
                <div class="col-xl-4 col-sm-6 text-center demo-effects">
                    <a [routerLink]="['/yoga']" class="app-preview demo-layouts">
                        <div class="trans-section">
                            <h4 class="preview-header">Yoga Layout</h4>
                        </div>
                        <div class="layout-images">
                            <div class="layout-container image-11"></div>
                        </div>
                    </a>
                </div>
                <div class="col-xl-4 col-sm-6 text-center demo-effects">
                    <a [routerLink]="['/e-commerce']" class="app-preview demo-layouts">
                        <div class="trans-section">
                            <h4 class="preview-header">Ecommerce Layout</h4>
                        </div>
                        <div class="layout-images">
                            <div class="layout-container image-12"></div>
                        </div>
                    </a>
                </div>
                <div class="col-xl-4 col-sm-6 text-center demo-effects">
                    <a [routerLink]="['/portfolio-layout']" class="app-preview demo-layouts">
                        <div class="trans-section">
                            <h4 class="preview-header">Portfolio Metro Layout</h4>
                        </div>
                        <div class="layout-images">
                            <div class="layout-container image-13"></div>
                        </div>
                    </a>
                </div>
                <div class="col-xl-4 col-sm-6 text-center demo-effects">
                    <div class="app-preview demo-layouts coming-soons">
                        <div class="trans-section">
                            <h4 class="preview-header">Coming Soon</h4>
                        </div>
                        <div class="layout-images">
                            <div class="layout-container">
                                <h3 class="coming-soon">COMING <br> SOON</h3>
                                <div class="animate-dot small-dot"></div>
                                <div class="animate-dot small-dot dot2"></div>
                                <div class="animate-dot small-dot dot3"></div>
                                <div class="animate-dot center-dot"></div>
                                <div class="animate-dot center-dot center-dot2"></div>
                                <div class="animate-dot center-dot center-dot3"></div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-xl-4 col-sm-6 text-center demo-effects">
                    <div class="app-preview demo-layouts coming-soons">
                        <div class="trans-section">
                            <h4 class="preview-header">Coming Soon</h4>
                        </div>
                        <div class="layout-images">
                            <div class="layout-container">
                                <h3 class="coming-soon">COMING <br> SOON</h3>
                                <div class="animate-dot small-dot"></div>
                                <div class="animate-dot small-dot dot2"></div>
                                <div class="animate-dot small-dot dot3"></div>
                                <div class="animate-dot center-dot"></div>
                                <div class="animate-dot center-dot center-dot2"></div>
                                <div class="animate-dot center-dot center-dot3"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="animat-demo">
        <img src="assets/images/landing/animate-icon/ract.png" class="img-fluid demo-ract1">
        <img src="assets/images/landing/animate-icon/squar.png" class="img-fluid demo-squar">
        <img src="assets/images/landing/animate-icon/sib-1.png" class="img-fluid demo-sib1">
        <img src="assets/images/landing/animate-icon/ract.png" class="img-fluid demo-ract3">
    </div>

</section>
<!--demo section end-->

<!--portfolio start-->
<section class="portfolio-section" id="portfolio">
    <div class="portfolio-back">
        <h1>portfolio page</h1>
    </div>
    <div class="container">
        <div class="row">
            <div class="col-12">
                <div class="title">
                    <h2>portfolio</h2>
                    <h6>portfolio</h6>
                    <hr class="bottom-border">
                </div>
            </div>
            <div class="col-12">
                <owl-carousel-o [options]="portfolioOptions" class="ecommerce-home-slider">
                    <ng-container *ngFor="let data of portfolio">
                        <ng-template carouselSlide>
                            <div>
                                <a [routerLink]="data.link" target="_blank">
                                    <div class="port-img">
                                        <img [src]="data.img" class="img-fluid">
                                    </div>
                                </a>
                            </div>
                        </ng-template>
                    </ng-container>
                </owl-carousel-o>
            </div>
        </div>
    </div>
    <div class="animat-potfolio">
        <img src="assets/images/landing/animate-icon/sib-1.png" class="img-fluid port-sib">
        <img src="assets/images/landing/animate-icon/round-2.png" class="img-fluid port-round">
        <img src="assets/images/landing/animate-icon/ract.png" class="img-fluid port-ract">
        <img src="assets/images/landing/animate-icon/squar.png" class="img-fluid port-squar">
    </div>
</section>
<!--portfolio end-->

<!--What's inside Unice start-->
<section class="whatinside" id="whatinside">
    <div class="container">
        <div class="position-relative o-hidden">
            <div class="text-as-bg">
                <h1>Features</h1>
            </div>
            <div class="title">
                <h2>What's inside Unice </h2>
                <p>Unice is ready with tons of demos and elements which is perfect for your project</p>
                <hr class="bottom-border">
            </div>
        </div>
        <div class="row">
            <div class="col-md-4">
                <div class="inside_box">
                    <h3>13+ Home layout</h3>
                    <p>Creative layout for you</p>
                </div>
            </div>
            <div class="col-md-4">
                <div class="inside_box">
                    <h3>25+ Blog Layout</h3>
                    <p>theme included 25 plus attractive layouts</p>
                </div>
            </div>
            <div class="col-md-4">
                <div class="inside_box">
                    <h3>30+ Ecommerce pages</h3>
                    <p>All Ecommerce pages added with theme</p>
                </div>
            </div>

            <div class="col-md-4">
                <div class="inside_box">
                    <h3>30+ Portfolio layouts</h3>
                    <p>30 plus layouts added for show you portfolio</p>
                </div>
            </div>
            <div class="col-md-4">
                <div class="inside_box">
                    <h3>11+ Extra pages</h3>
                    <p>11 extra bones pages added</p>
                </div>
            </div>
            <div class="col-md-4">
                <div class="inside_box">
                    <h3>25+ Elements</h3>
                    <p>Yes, theme included 25 unique elements</p>
                </div>
            </div>

        </div>
    </div>
</section>
<!--What's inside Unice ends-->

<!--Blog start-->
<section class="portfolio-section" id="blog">
    <div class="portfolio-back">
        <h1>Blog page</h1>
    </div>
    <div class="container">
        <div class="row">
            <div class="col-12">
                <div class="title">
                    <h2>Blog</h2>
                    <h6>Blog pages</h6>
                    <hr class="bottom-border">
                </div>
            </div>
            <div class="col-12">
                <owl-carousel-o [options]="blogOptions">
                    <ng-container *ngFor="let data of blog">
                        <ng-template carouselSlide>
                            <div>
                                <a [routerLink]="data.link" target="_blank">
                                    <div class="port-img">
                                        <img [src]="data.img" class="img-fluid blur-up lazyload">
                                    </div>
                                </a>
                            </div>
                        </ng-template>
                    </ng-container>
                </owl-carousel-o>
            </div>
        </div>
    </div>
    <div class="animat-potfolio">
        <img src="assets/images/landing/animate-icon/sib-1.png" class="img-fluid port-sib">
        <img src="assets/images/landing/animate-icon/round-2.png" class="img-fluid port-round">
        <img src="assets/images/landing/animate-icon/ract.png" class="img-fluid port-ract">
        <img src="assets/images/landing/animate-icon/squar.png" class="img-fluid port-squar">
    </div>
</section>
<!--Blog end-->

<!--elemant start-->
<section class="elemant-bounce">
    <div class="elemant-back">
        <h1>extra bonus element</h1>
    </div>
    <div class="container">
        <div class="row">
            <div class="col-12">
                <div class="title">
                    <h2>Elemant</h2>
                    <h6>extra-bonus</h6>
                    <hr class="bottom-border">
                </div>
            </div>
            <div class="col-12">
                <div class="elemant-bounce-contant">
                    <img src="assets/images/landing/element/1.png" class="img-fluid" alt="element-img">
                </div>
            </div>
        </div>
    </div>
    <div class="animat-elimat">
        <img src="assets/images/landing/animate-icon/ract.png" class="img-fluid element-rect">
        <img src="assets/images/landing/animate-icon/round-2.png" class="img-fluid element-round">
        <img src="assets/images/landing/animate-icon/sib-1.png" class="img-fluid element-sib">
        <img src="assets/images/landing/animate-icon/squar.png" class="img-fluid element-squar">
    </div>
</section>
<!--elemant end-->

<!--core feature start-->
<section class="advance-feature" id="feature">
    <div class="core-back">
        <h1>core<br> feature</h1>
    </div>
    <div class="features-container">
        <div class="container">
            <div class="row d-flex justify-content-center">
                <div class="col-12">
                    <div class="title">
                        <h2>core features</h2>
                        <h6>core features</h6>
                        <hr class="bottom-border">
                    </div>
                </div>
                <div class="feature-main">
                    <div class="feature">
                        <div class="feature-icon">
                            <img src="assets/images/landing/features-icon/1.png" alt="" class="img-fluid feature-img">
                        </div>
                    </div>
                </div>
                <div class="feature-main">
                    <div class="feature">
                        <div class="feature-icon">
                            <img src="assets/images/landing/features-icon/2.png" alt="" class="img-fluid feature-img">
                        </div>
                    </div>
                </div>
                <div class="feature-main">
                    <div class="feature">
                        <div class="feature-icon">
                            <img src="assets/images/landing/features-icon/3.png" alt="" class="img-fluid feature-img">
                        </div>
                    </div>
                </div>
                <div class="feature-main">
                    <div class="feature">
                        <div class="feature-icon">
                            <img src="assets/images/landing/features-icon/4.png" alt="" class="img-fluid feature-img">
                        </div>
                    </div>
                </div>
                <div class="feature-main">
                    <div class="feature">
                        <div class="feature-icon">
                            <img src="assets/images/landing/features-icon/5.png" alt="" class="img-fluid feature-img">
                        </div>
                    </div>
                </div>
                <div class="feature-main">
                    <div class="feature">
                        <div class="feature-icon">
                            <img src="assets/images/landing/features-icon/6.png" alt="" class="img-fluid feature-img">
                        </div>
                    </div>
                </div>
                <div class="feature-main">
                    <div class="feature">
                        <div class="feature-icon">
                            <img src="assets/images/landing/features-icon/7.png" alt="" class="img-fluid feature-img">
                        </div>
                    </div>
                </div>
                <div class="feature-main">
                    <div class="feature">
                        <div class="feature-icon">
                            <img src="assets/images/landing/features-icon/8.png" alt="" class="img-fluid feature-img">
                        </div>
                    </div>
                </div>
                <div class="feature-main">
                    <div class="feature">
                        <div class="feature-icon">
                            <img src="assets/images/landing/features-icon/9.png" alt="" class="img-fluid feature-img">
                        </div>
                    </div>
                </div>
                <div class="feature-main">
                    <div class="feature">
                        <div class="feature-icon">
                            <img src="assets/images/landing/features-icon/10.png" alt="" class="img-fluid feature-img">
                        </div>
                    </div>
                </div>
                <div class="feature-main">
                    <div class="feature">
                        <div class="feature-icon">
                            <img src="assets/images/landing/features-icon/11.png" alt="" class="img-fluid feature-img">
                        </div>
                    </div>
                </div>
                <div class="feature-main">
                    <div class="feature">
                        <div class="feature-icon">
                            <img src="assets/images/landing/features-icon/12.png" alt="" class="img-fluid feature-img">
                        </div>
                    </div>
                </div>
                <div class="feature-main">
                    <div class="feature">
                        <div class="feature-icon">
                            <img src="assets/images/landing/features-icon/13.png" alt="" class="img-fluid feature-img">
                        </div>
                    </div>
                </div>
                <div class="feature-main">
                    <div class="feature">
                        <div class="feature-icon">
                            <img src="assets/images/landing/features-icon/14.png" alt="" class="img-fluid feature-img">
                        </div>
                    </div>
                </div>
                <div class="feature-main">
                    <div class="feature">
                        <div class="feature-icon">
                            <img src="assets/images/landing/features-icon/15.png" alt="" class="img-fluid feature-img">
                        </div>
                    </div>
                </div>
                <div class="feature-main">
                    <div class="feature">
                        <div class="feature-icon">
                            <img src="assets/images/landing/features-icon/16.png" alt="" class="img-fluid feature-img">
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="animat-cor">
        <img src="assets/images/landing/animate-icon/sib-1.png" class="cor-sib">
        <img src="assets/images/landing/animate-icon/round-2.png" class="cor-round">
        <img src="assets/images/landing/animate-icon/ract.png" class="cor-ract">
        <img src="assets/images/landing/animate-icon/squar.png" class="cor-squar1">
        <img src="assets/images/landing/animate-icon/squar.png" class="cor-squar2">
    </div>
</section>
<!--core feature end-->

<!--testimonial start-->
<section class="testimonial-main">
    <div class="testimonial-back">
        <h1>testimonial</h1>
    </div>
    <div class="container">
        <div class="row">
            <div class="col-12">
                <div class="title">
                    <h2>testimonial</h2>
                    <h6>happy-client</h6>
                    <hr class="bottom-border">
                </div>
            </div>
            <div class="col-xl-6 offset-xl-3">
                <div class="testimonial-contain">
                    <owl-carousel-o [options]="testimonialOptions" class="ecommerce-home-slider">
                        <ng-container *ngFor="let data of testimonial">
                            <ng-template carouselSlide>
                                <div>
                                    <div class="testimonial-right">
                                        <div class="media">
                                            <img src="assets/images/landing/testimonial.png" class="img-fluid"
                                                alt="testimonial">
                                            <div class="media-body">
                                                <h5>{{data.name}}</h5>
                                                {{data.sortDescription}}
                                            </div>
                                        </div>
                                        <p>{{data.fullDescription}}</p>
                                    </div>
                                </div>
                            </ng-template>
                        </ng-container>
                    </owl-carousel-o>
                </div>
            </div>
        </div>
    </div>
    <div class="animat-test">
        <img src="assets/images/landing/animate-icon/sib-1.png" class="test-sib">
        <img src="assets/images/landing/animate-icon/round-2.png" class="test-round">
        <img src="assets/images/landing/animate-icon/ract.png" class="test-ract">
        <img src="assets/images/landing/animate-icon/squar.png" class="test-squar1">
        <img src="assets/images/landing/animate-icon/squar.png" class="test-squar2">
    </div>
</section>
<!--testimonial end-->

<!--rat-section start-->
<section class="rate-us-section">
    <div class="rate-us-back">
        <h1>Any Problem</h1>
    </div>
    <div class="container">
        <div class="row">
            <div class="col-12">
                <div class="rate-us-contain">
                    <div>
                        <div class="rating-porson">
                            <img src="assets/images/landing/rating-parson.png" class="img-fluid" alt="rating-paron">
                        </div>
                        <h1>Have Any Problem ?</h1>
                        <p>No Worries-Support Services is Always To Support You</p>
                        <a href="#" class="btn-gradient ">purchase now</a>
                        <ul class="ratin-start">
                            <li><i class="fa fa-star"></i></li>
                            <li><i class="fa fa-star"></i></li>
                            <li><i class="fa fa-star"></i></li>
                            <li><i class="fa fa-star"></i></li>
                            <li><i class="fa fa-star"></i></li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="animat-rat">
        <img src="assets/images/landing/animate-icon/sib-1.png" class="rat-sib">
        <img src="assets/images/landing/animate-icon/round-2.png" class="rat-round">
        <img src="assets/images/landing/animate-icon/ract.png" class="rat-ract">
        <img src="assets/images/landing/animate-icon/squar.png" class="rat-squar1">
        <img src="assets/images/landing/animate-icon/squar.png" class="rat-squar2">
    </div>
</section>
<!--rat-section end-->

<!-- footer start -->
<footer class="footer-main">
    <div class="container">
        <div class="row">
            <div class="col-6">
                <div class="footer-left">
                    <div class="footer-logo">
                        <img src="assets/images/landing/logo.png" alt="footer-logo" class="img-fluid">
                    </div>
                </div>
            </div>
            <div class="col-6 align-self-center">
                <div class="footer-right">
                    <p>&copy; 2019 All right reserved</p>
                </div>
            </div>
        </div>
    </div>
</footer>
<!--footer end-->
<!-- Tap on Top-->
<div class="tap-top">
    <div><i class="fa fa-angle-double-up"></i></div>
</div>
<!-- Tap on Ends-->